export enum TraditionalTypes {
  Hoarding = 1,
  Television = 2,
  Cinema = 5,
  Radio = 3,
  Magazine = 4,
  NewsPaper = 6,
  Pamphlet = 7
}
